import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'template-document-grid',
  templateUrl: './template-document-grid.component.html',
  styleUrl: './template-document-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateDocumentGridComponent implements OnInit, OnDestroy {
  @Input() allChecked = false;
  @Input() hideCheckbox = false;
  @Input() fileListItems: any[] = [];
  @Input() hideSelectAllCheckbox = false;
  @Output() templateDocumentGridEvent = new EventEmitter<any>();

  hoveredFile = null;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}

  onValueChange(event: any, file: any, index: number) {
    this.templateDocumentGridEvent.emit({
      type: 'onValueChange',
      event,
      file,
      index,
    });
  }
  handleFilterChange(event: any) {
    this.templateDocumentGridEvent.emit({
      type: 'handleFilterChange',
      event,
    });
  }
  toggleChecklistAll(event: any) {
    this.templateDocumentGridEvent.emit({
      type: 'toggleChecklistAll',
      event,
    });
  }
  ngOnDestroy(): void {}

  downloadFile(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'downloadFile',
      item,
    });
  }
  viewModal(item: any, event: any) {
    this.templateDocumentGridEvent.emit({
      type: 'viewModal',
      item,
      event,
    });
  }
  openShareModal(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'openShareModal',
      item,
    });
  }
  openCannotShareWarningDilaog() {
    this.templateDocumentGridEvent.emit({
      type: 'openCannotShareWarningDilaog',
    });
  }
  duplicateTemplate(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'duplicateTemplate',
      item,
    });
  }
  openCreateShareLinkDialog(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'openCreateShareLinkDialog',
      item,
    });
  }
  openActivityLogModel(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'openActivityLogModel',
      item,
    });
  }
  moveAssetSingleItem(item: any, itemId: any) {
    this.templateDocumentGridEvent.emit({
      type: 'moveAssetSingleItem',
      item,
      itemId,
    });
  }
  deleteFileFunction(item: any) {
    this.templateDocumentGridEvent.emit({
      type: 'deleteFileFunction',
      item,
    });
  }
}
